import { Button } from '@/components/ui/button';
import {
  Card,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { accessTokenCookieName } from '@/lib/constants';
import { ArrowRight } from 'lucide-react';
import Cookies from 'js-cookie';
import { useGetAllApiList } from '@/services/data-services/Apis';
import { Skeleton } from '@/components/ui/skeleton';
import { NoResult } from '@/assets/icons';
import { cn } from '@/lib/utils';
import { useSearchParams } from 'react-router';
import { useEffect } from 'react';

const ApiCards = ({
  setResponseData,
  setSelectedApi,
  selectedTab,
  setIsAuth,
  isWidget = false,
}) => {
  const [searchParams] = useSearchParams();
  const token = isWidget
    ? searchParams.get('accessToken')
    : Cookies.get(accessTokenCookieName);
  const apiQueryParams = `all=true${selectedTab && selectedTab !== 'ALL' ? `&category=${selectedTab}` : ''}`;
  const { data, isLoading, error } = useGetAllApiList(token, apiQueryParams);

  useEffect(() => {
    if (
      (error?.status === 403 && isWidget) ||
      (error?.status === 401 && isWidget)
    ) {
      setIsAuth(false);
    }
  }, [error]);

  const allApi = data?.data?.docs || [];
  const handleApiSelect = (value) => {
    setResponseData(null);
    const selected = allApi.find((api) => api?.documentType === value);
    setSelectedApi(selected ? selected : null);
  };

  const getCustomDescription = (documentType) => {
    switch (documentType) {
      case 'CCRV_GENERATE_REQUEST':
        return 'Court and criminal record verification can be run using Name, Father’s Name, Address and DOB (Date of Birth) of the Candidate. Please check for accuracy in details before Submission. ';
      case 'EMPLOYMENT_COMPOSITE_API':
        return 'Employment History verification can be run using either PAN Number OR Aadhar Number. Please check for accuracy in details before Submission.';
      default:
        return null;
    }
  };

  const shouldShowPrice = () => {
    if (!isWidget) return true;
  };

  return (
    <div
      className={cn(
        'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-4 gap-5',
        !isLoading &&
          allApi?.length === 0 &&
          'grid-cols-1 md:grid-cols-1 lg:grid-cols-1 xl:grid-cols-1 2xl:grid-cols-1',
      )}
    >
      {allApi?.length > 0 &&
        allApi?.map((api, index) => (
          <Card
            key={index}
            className="shadow-md hover:shadow-lg flex flex-col justify-between h-full"
          >
            <CardHeader className="p-5 min-h-36">
              <CardTitle className="text-foreground text-xl">
                {api?.name}
              </CardTitle>
              <CardDescription className="text-foreground">
                {getCustomDescription(api?.documentType) || api?.description}
              </CardDescription>
            </CardHeader>
            <div className="flex items-center text-foreground font-semibold justify-between px-5 mb-5 mt-auto max-sm:flex-col max-sm:gap-4">
              <Button
                className="max-sm:w-full"
                onClick={() => handleApiSelect(api?.documentType)}
              >
                {isWidget ? 'Run Now' : 'Try Now'} &nbsp; <ArrowRight />
              </Button>
              {shouldShowPrice(api?.documentType) && (
                <div className="max-sm:text-sm">
                  &#8377;{' '}
                  {api?.documentType === 'CCRV_GENERATE_REQUEST'
                    ? 70
                    : api?.documentType === 'AADHAAR_DETAILED_GENERATE_OTP'
                      ? 2.5
                      : typeof api?.price === 'number'
                        ? api?.price
                        : api?.price?.$numberDecimal}
                  /API
                </div>
              )}
            </div>
          </Card>
        ))}
      {isLoading &&
        Array.from({ length: 8 }).map((_, index) => (
          <Skeleton key={index} className="h-48 bg-input" />
        ))}
      {!isLoading && allApi?.length === 0 && (
        <div className="flex flex-col font-medium items-center justify-center p-5 h-full w-full">
          <NoResult width={400} height={400} />
          <p className="text-xl">No APIs found</p>
        </div>
      )}
    </div>
  );
};

export default ApiCards;
